import { Controller } from "@hotwired/stimulus";
import { animate } from "animejs";

function csrfToken() {
  return (document.querySelector('meta[name="csrf-token"]') || {}).content || "";
}

export default class extends Controller {
  static values = { tenant: String, msgDone: String, msgFailed: String };
  static targets = ["volume", "feedback"];

  disconnect() {
    clearTimeout(this._feedbackTimer);
  }

  async setVolume(_event) {
    const level = parseInt(this.volumeTarget.value, 10);
    try {
      const response = await fetch("/api/v1/obs/volume", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken(),
          Accept: "application/json",
        },
        body: JSON.stringify({ level, tenant_slug: this.tenantValue }),
      });
      if (!response.ok) throw new Error("Request failed");
      this.feedbackTarget.textContent = this.msgDoneValue || "Done!";
      this._fadeFeedback(2000);
    } catch {
      this.feedbackTarget.textContent = this.msgFailedValue || "Failed";
      this._fadeFeedback(3000);
    }
  }

  _fadeFeedback(holdMs) {
    clearTimeout(this._feedbackTimer);
    this.feedbackTarget.style.opacity = "1";
    this._feedbackTimer = setTimeout(() => {
      animate(this.feedbackTarget, {
        opacity: 0,
        duration: 400,
        ease: "outQuad",
        onComplete: () => {
          this.feedbackTarget.textContent = "";
          this.feedbackTarget.style.opacity = "";
        },
      });
    }, holdMs);
  }

  async setMute(event) {
    const muted = event.params.muted;
    try {
      const response = await fetch("/api/v1/obs/mute", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken(),
          Accept: "application/json",
        },
        body: JSON.stringify({ muted, tenant_slug: this.tenantValue }),
      });
      if (!response.ok) throw new Error("Request failed");
      this.feedbackTarget.textContent = this.msgDoneValue || "Done!";
      this._fadeFeedback(2000);
    } catch {
      this.feedbackTarget.textContent = this.msgFailedValue || "Failed";
      this._fadeFeedback(3000);
    }
  }
}
